import { NextSeo } from 'next-seo';

//screens
import { DockDoorManagement } from '@/screens/Agents/DockDoorManagement';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';

export default function DockDoorManagementPage() {
  return (
    <>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        canonical="https://loadsmart.com/ai/dock-door-management/"
        title="Dock Door Management Agent | Loadsmart AI"
        description="Runs the day-to-day flow of trucks in and out of your docks, handling late arrivals, no-shows and dock closures, and keeps the day on plan with daily dock briefings, appointment reminders and automatic appointment confirmations."
        openGraph={{
          url: 'https://loadsmart.com/ai/dock-door-management/',
          images: [
            {
              url: `${process.env.SITE_URL}/images/share/ai/dock-door-management.png`,
              width: 1200,
              height: 630,
              alt: 'Dock Door Management Agent',
              type: 'image/png',
            },
          ],
        }}
      />
      <JsonLd data={Organization} />
      <DockDoorManagement />
    </>
  );
}
